import { NavLink } from "react-router-dom";

import './styles.scss';

type ButtonOrLinkProps =
    | ({
        as: 'button'|'submit'|'reset';
        onClick: () => void;
        url?: never;
    })
    | ({
        as: 'a';
        url: string;
        onClick?: never;
    });

type Props = ButtonOrLinkProps & {
    id?: string;
    title: string;
    subTitle: string;
    iconClassName: string;
    className: string;
};


const Button = ({ as, iconClassName, className, id, subTitle, title, onClick, url }: Props) => {
    const handleOnClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        onClick && onClick();
    }

    const children = (
        <>
            <div className="d-flex flex-column min-w-70">
                <h5>{title}</h5>
                <h6>{subTitle}</h6>
            </div>
            <i className={iconClassName}></i>
            <i className="fas fa-chevron-right"></i>
        </>
    )

    return (
        as === 'a' ? (
            <NavLink to={url ?? ''} id={id} className={`button ${className}`}>
                {children}
            </NavLink>
        ) : (
            <button type={as} onClick={handleOnClick} id={id} className={`button ${className}`}>
                {children}
            </button>
        )
    )
};

export default Button;